var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.588.8a.719.719 0 0 0-.706.582l-.24 1.235a5.748 5.748 0 0 0-1.618.93L2.84 3.138a.72.72 0 0 0-.858.32L.897 5.341a.721.721 0 0 0 .15.904l.95.825c-.05.304-.082.613-.082.93 0 .317.032.626.081.93l-.949.825a.721.721 0 0 0-.15.904l1.085 1.882a.72.72 0 0 0 .858.322l1.184-.408c.48.394 1.027.705 1.617.928l.24 1.235a.719.719 0 0 0 .707.582h2.174c.345 0 .64-.244.706-.582l.24-1.235a5.748 5.748 0 0 0 1.617-.93l1.184.408a.72.72 0 0 0 .858-.32l1.086-1.883a.72.72 0 0 0-.15-.903l-.95-.825c.05-.304.082-.613.082-.93 0-.317-.033-.626-.082-.93l.95-.825a.721.721 0 0 0 .15-.904l-1.086-1.882a.72.72 0 0 0-.858-.322l-1.184.408a5.749 5.749 0 0 0-1.617-.928l-.24-1.235A.719.719 0 0 0 8.762.8H6.588zm1.087 4.32a2.88 2.88 0 1 1 0 5.76 2.88 2.88 0 0 1 0-5.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.867d02475a3279bdc3f86060193bb8da.svg";
export { ForwardRef as ReactComponent };